import i18n from "i18n";

export const infoHubChartSchema = [
  {
    id: 1,
    name: "Voulgari to Train station",
    endpoint: "/rpc/get_infohub_path?p_path_id=1",
    xField: "timestamp", // datetime
    yField: "tt", // travel time
    groupField: "meso", // "car", "bus", "metro", etc.
    axiosXLabel: i18n.t("trafficMonitoring.infohub.chart.axisTime"),
    axiosYLabel: i18n.t("trafficMonitoring.infohub.chart.axisTravelTime"),
  },
    {
    id: 2,
    name: "Train station to Voulgari",
    endpoint: "/rpc/get_infohub_path?p_path_id=5",
    xField: "timestamp", // datetime
    yField: "tt", // travel time
    groupField: "meso", // "car", "bus", "metro", etc.
    axiosXLabel: i18n.t("trafficMonitoring.infohub.chart.axisTime"),
    axiosYLabel: i18n.t("trafficMonitoring.infohub.chart.axisTravelTime"),
  },
];
